<div class="insurance">
	<router-outlet>
	</router-outlet>
</div>